// Module
var code = "<div class=\"im-videoviewer\"> <video class=\"im-video-player\" preload=\"auto\" controls=\"controls\"></video> </div>";
// Exports
module.exports = code;